// utils/api-dim-calibrations.js
import { supabase } from './supabase';

// Crear una calibración Dimensional (status in-progress)
export async function createDimensionalCalibration(instrumentId, { procedure = 'DIM-LONG v1', ambient = {} } = {}) {
  const { data, error } = await supabase
    .from('calibrations')
    .insert({
      instrument_id: instrumentId,
      procedure_version: procedure,
      ambient_temp: ambient.temp ?? null,
      ambient_humidity: ambient.hum ?? null,
      status: 'in-progress',
      priority: 'low'
    })
    .select('id, instrument_id, date, status')
    .single();
  if (error) throw error;
  return data;
}

// Cerrar calibración (marca status y mantiene coherencia con triggers ya definidos)
export async function closeDimensionalCalibration(calibrationId) {
  const { error } = await supabase
    .from('calibrations')
    .update({ status: 'closed', date: new Date().toISOString() })
    .eq('id', calibrationId);
  if (error) throw error;
  return true;
}
